var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:[
      {
        'has-text-weight-bold': _vm.option.isSelected,
        'has-text-weight-medium': !_vm.option.isSelected
      },
      {
        'has-text-grey-dark':
          _vm.$mq === 'mobile' || (_vm.option.isSelected && _vm.$mq !== 'mobile')
      }
    ]},[_vm._v(_vm._s(_vm.option.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }